import { AuthMethod } from 'config/constants';
import {
  getQffAuth,
  addQffLoginListener,
  addQffLogoutListener,
  addQffInitCompletedListener,
  addQffOnProfileUpdateListener,
} from 'lib/qffAuth/authWidgetApi';
import { loginSuccess } from 'lib/gaTracking/crossPageEvents';
import { ssoLoginSuccess, ssoLogoutSuccess, ssoInitCompleted, ssoSyncProfile } from './actions';

const getQffUserInfo = () => {
  const qffAuth = getQffAuth();

  return {
    memberId: qffAuth.getMemberId(),
    title: qffAuth.getTitle(),
    firstName: qffAuth.getFirstName(),
    lastName: qffAuth.getLastName(),
    pointsBalance: qffAuth.getPoints(),
    membershipTier: qffAuth.getMembershipTier(),
    token: qffAuth.getAccessToken(),
    isAuthenticated: qffAuth.isAuthenticated(),
  };
};

const subscribeSsoInitCompleted = (dispatch) => {
  addQffInitCompletedListener(() => {
    const payload = getQffUserInfo();
    dispatch(ssoInitCompleted(payload));
  });
};

const subscribeSsoLoginSuccess = (dispatch) => {
  addQffLoginListener(() => {
    const payload = getQffUserInfo();
    dispatch(ssoLoginSuccess(payload));
    loginSuccess(AuthMethod.WIDGET);
  });
};

const subscribeSsoOnProfileUpdate = (dispatch) => {
  addQffOnProfileUpdateListener(() => {
    const payload = getQffUserInfo();
    dispatch(ssoSyncProfile(payload));
  });
};

const subscribeSsoLogoutSuccess = (dispatch) => {
  addQffLogoutListener(() => {
    dispatch(ssoLogoutSuccess());
  });
};

export const subscribeToQffEvents = (dispatch) => {
  subscribeSsoInitCompleted(dispatch);
  subscribeSsoLoginSuccess(dispatch);
  subscribeSsoLogoutSuccess(dispatch);
  subscribeSsoOnProfileUpdate(dispatch);
};
